import { infoNotification } from '@sceneio/cms-notifications'
import {
  logout,
  useUserDispatch,
} from '@sceneio/content-store/lib/features/user/userSlice'
import { getCookie, setCookie, deleteCookie } from '@sceneio/tools'

const FORCE_LOGOUT_COOKIE_NAME = 'shouldForceLogout'

function saveForceLogoutCookie() {
  setCookie(FORCE_LOGOUT_COOKIE_NAME, 'true', 10)
}

function loadForceLogoutCookie() {
  const shouldForceLogout =
    (getCookie(FORCE_LOGOUT_COOKIE_NAME) || '') === 'true'
  return shouldForceLogout
}

export function useForceReloadNotification({
  content = 'A new version has been detected. The browser will reload in a few seconds.',
  autoClose = 5000,
  onLogout,
}: {
  content?: string
  autoClose?: number
  onLogout?: () => void
}) {
  return () => {
    const shouldForceLogout = loadForceLogoutCookie()

    if (shouldForceLogout) {
      console.error('[useForceReloadNotification]: Forced logout occurred')
      deleteCookie(FORCE_LOGOUT_COOKIE_NAME)
      onLogout && onLogout()
      return
    }

    infoNotification({
      content,
      options: {
        autoClose,
        style: {
          '--toastify-color-progress-info': 'rgb(96 165 250)',
        } as React.CSSProperties,
        type: 'info',
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        toastId: 'force-reload-notification',
        onClose: () => {
          saveForceLogoutCookie()
          window.location.reload()
        },
        hideProgressBar: false,
      },
    })
  }
}
